<template>
    <div>Error - file not found. (vueinclude)</div>
</template>

<script>
export default {
    name: "vue-include-error",
};
</script>